export default __webpack_public_path__ + "static/media/instagramLogo2.534fd6b8.svg";